import { render, staticRenderFns } from "./VipItem.vue?vue&type=template&id=aaff8424&scoped=true&"
import script from "./VipItem.vue?vue&type=script&lang=js&"
export * from "./VipItem.vue?vue&type=script&lang=js&"
import style0 from "./VipItem.vue?vue&type=style&index=0&id=aaff8424&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aaff8424",
  null
  
)

export default component.exports